export interface UsersSlice {
  isUserSaving: boolean;
  isSendingUserInvitation: boolean;
  setIsUserSaving: (v: boolean) => void;
  setIsSendingUserInvitation: (v: boolean) => void;
}

export const createUsersSlice = (set: any): UsersSlice => ({
  isUserSaving: false,
  isSendingUserInvitation: false,
  setIsUserSaving: (v) => set({ isUserSaving: v }),
  setIsSendingUserInvitation: (v) => set({ isSendingUserInvitation: v }),
});
